import { $ } from './../../helpers/query';
import Swiper from 'swiper/bundle';

export default () => {

  $('.gallery').each(section => {

    const carousel = $('.gallery__carousel');

    const swiper = new Swiper(carousel.elem, {
      speed: 800,
      loop: true,
      loopAdditionalSlides: 1,
      spaceBetween: 9,
      navigation: {
        prevEl: section.querySelector('.gallery__prev'),
        nextEl: section.querySelector('.gallery__next'),
      },
    });

  });

}
